const actions = {
  GET_LIST_TIMESHEET: "GET_LIST_TIMESHEET",
  GET_LIST_TIMESHEET_SUCCESS: "GET_LIST_TIMESHEET_SUCCESS",
  GET_LIST_TIMESHEET_ERROR: "GET_LIST_TIMESHEET_ERROR",

  SAVE_TIMESHEET: "SAVE_TIMESHEET",
  SAVE_TIMESHEET_SUCCESS: "SAVE_TIMESHEET_SUCCESS",
  SAVE_TIMESHEET_ERROR: "SAVE_TIMESHEET_ERROR",

  getListTimesheet: (payload) => ({
    type: actions.GET_LIST_TIMESHEET,
    payload,
  }),

  saveTimesheet: (payload) => ({
    type: actions.SAVE_TIMESHEET,
    payload,
  }),
};

export default actions;
